import React, { useRef, useState } from 'react';
import { RootState } from '../../../../redux/store';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import { useSelector } from 'react-redux';

import { IBoardsDropdown } from '../../types/IBoardsDropdown';

import Icon from '../../../ui/icon/icon';
import DashboardObjectPicker from '../dashboardObjectPicker/dashboardObjectPicker';

import './boardsDropdown.scss';

const BoardsDropdown: React.FC<IBoardsDropdown> = ({
                                                     loading,
                                                     objects,
                                                     periods,
                                                     currencies,
                                                     onObjectChange,
                                                     onPeriodChange,
                                                     onCurrenciesChange,
                                                     onCustomisationChange,
                                                     filteredNotes,
                                                     selectedCurrency,
                                                     selectedObject,
                                                   }) => {
  const [notesShown, setNotesShown] = useState(false);

  const investor = useSelector((state: RootState) => state.investor.investor);
  const impersonate = useSelector((state: RootState) => state.impersonate);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const clickOutsideHandler = () => {
    setNotesShown(false);
  };

  useClickOutside(wrapperRef, clickOutsideHandler, 'notes-icon');

  const toggleNotes = (): void => {
    setNotesShown(!notesShown);
  };

  const hideObject = () => {
    if (investor.id) {
      if (objects.length === 1) {
        return parseInt(objects[0].objectPath) !== investor.id;
      }
    }
    return true;
  };

  return (
    <div className={'dropdown-wrapper-container'}>
      <div className={'dropdown-wrapper'}>
        {!loading && (
          <>
            {objects && hideObject() && (
              <DashboardObjectPicker selectedObject={selectedObject} selectedCurrency={selectedCurrency}
                                     onObjectChangeCallback={onObjectChange} dataArray={objects} type='objects'
                                     className={'split-margin'} />
            )}
            {currencies &&
              <DashboardObjectPicker selectedCurrency={selectedCurrency} onObjectChangeCallback={onCurrenciesChange}
                                     dataArray={currencies}
                                     type='currencies' />}
            {periods &&
              <DashboardObjectPicker selectedCurrency={selectedCurrency} onObjectChangeCallback={onPeriodChange}
                                     dataArray={periods} type='periods' />}
            {filteredNotes.length > 0 && (
              <div className='notes-wrapper'>
                <Icon name={`${notesShown ? 'far' : 'fas'} fa-circle-info`} className='notes-info pointer'
                      onClick={toggleNotes} id={'notes-icon'} />
                {notesShown && (
                  <div className='notes-content' ref={wrapperRef}>
                    {filteredNotes.map((note, key) => (
                      <p key={key}>
                        {note.symbol} {note.note}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            )}

            {!impersonate.impersonate && (
              <div className='notes-wrapper hidden-mobile settings-icon'>
                <Icon name={'fa-solid fa-gear'} className={'pointer'} onClick={() => onCustomisationChange(true)} />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BoardsDropdown;